import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { MapPin, Shield } from "lucide-react";
import Testimonials from "../components/Testimonials";
import { useNavigate } from "react-router-dom";

function PillCard({ title, description }) {
  return (
    <div className="bg-white border border-[#eadce6] rounded-3xl max-md:shadow-md px-5 py-6 sm:px-4 sm:py-6 flex flex-col items-center text-center gap-3 h-full">
      <span className="h-12 w-12 rounded-full bg-[#f2e7ee] flex items-center justify-center text-[#61013B]">
        <Shield className="w-6 h-6" />
      </span>
      <h3 className="text-base font-bold text-[#61013B]">{title}</h3>
      <p className="text-sm text-black font-medium leading-relaxed">
        {description}
      </p>
    </div>
  );
}

function Step({ number, title, description, isPrimary, isLast }) {
  return (
    <div className={`flex items-start gap-4 relative ${!isLast ? "pb-1" : ""}`}>
      <div className="flex flex-col items-center">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${
            isPrimary
              ? "bg-[#570033] text-white border border-[#570033]"
              : "bg-white text-[#570033] border border-[#570033]"
          }`}
        >
          {number}
        </div>
        {!isLast && <div className="w-px h-14 bg-[#E5D0DB] mt-1"></div>}
      </div>

      <div className="space-y-1 pt-1">
        <h4 className="text-lg font-semibold text-[#570033]">{title}</h4>
        <p className="text-sm text-[#5f6b7a] leading-relaxed">{description}</p>
      </div>
    </div>
  );
}


function HomeRides() {
  const navigate = useNavigate();
  const [scheduleOption, setScheduleOption] = useState("Now");
  const steps = [
    {
      number: "01.",
      title: "Request a ride",
      description: "Enter your destination and choose your ride preference.",
    },
    {
      number: "02.",
      title: "Meet it works",
      description: "Your driver arrives at your pick up location.",
    },
    {
      number: "03.",
      title: "Enjoy the ride",
      description: "Sit back, relax and enjoy your journey to your destination.",
    },
  ];

  return (
    <div className="bg-white min-h-screen">
      <Header />

      <main className="pb-16 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-0 lg:max-w-[80%] space-y-10">
        {/* Mobile standalone booking form */}
        <section className="sm:hidden w-full">
          <div className="max-w-xl mx-auto sm:rounded-2xl sm:bg-white sm:shadow-lg sm:border sm:border-[#c6cbd5] p-5 space-y-4">
            <div className="flex flex-col gap-2">
              <label className="text-sm text-gray-800 font-semibold">
                Pickup
              </label>
              <input
                type="text"
                placeholder="Enter pickup location"
                className="w-full rounded-xl border border-[#b8c1d0] px-4 py-3 text-base text-gray-800 outline-none focus:border-[#570033] focus:ring-2 focus:ring-[#570033]/20 placeholder:text-gray-500"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-sm text-gray-800 font-semibold">
                Destination
              </label>
              <input
                type="text"
                placeholder="Enter destination"
                className="w-full rounded-xl border border-[#b8c1d0] px-4 py-3 text-base text-gray-800 outline-none focus:border-[#570033] focus:ring-2 focus:ring-[#570033]/20 placeholder:text-gray-500"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-sm text-gray-800 font-semibold">
                Schedule for later
              </label>
              <div className="relative">
                <input
                  list="home-rides-schedule"
                  value={scheduleOption}
                  onChange={(e) => setScheduleOption(e.target.value)}
                  className="w-full rounded-xl border border-[#b8c1d0] px-4 py-3 text-base text-gray-800 outline-none focus:border-[#570033] focus:ring-2 focus:ring-[#570033]/20 bg-white"
                  placeholder="Select schedule"
                />
                <datalist id="home-rides-schedule">
                  <option value="Now" />
                  <option value="In 15 minutes" />
                  <option value="In 30 minutes" />
                  <option value="In 1 hour" />
                  <option value="Tomorrow" />
                </datalist>
              </div>
            </div>

            <button
              className="w-full bg-[#570033] text-white rounded-xl px-4 py-3 flex items-center justify-center gap-2 text-base font-semibold hover:bg-[#6f0044] transition-colors"
              type="button"
              onClick={() => navigate("/auth/login")}
            >
              Book Ride
            </button>
          </div>
        </section>

        {/* Hero hidden on mobile */}
        <section className="hidden sm:flex flex-col lg:flex-row items-stretch gap-10">
          
          <div className="flex-1 flex flex-col my-40 justify-between ">
            <div className="space-y-5">
              <h1 className="text-3xl sm:text-4xl font-bold text-[#570033] leading-tight">
              Your Ride, Your Way— <br className="hidden sm:block" />
              Anytime, Anywhere.
            </h1>
            <p className="text-sm sm:text-base text-gray-700 font-medium">
              From quick city trips to long-distance journeys, we’ve got you
              covered.
            </p>
             
            <div className="flex flex-wrap gap-4">
              <button
                className="bg-[#570033] text-white px-4 sm:px-5 py-2 rounded shadow hover:bg-[#6c0a46] text-sm font-medium"
                type="button"
                onClick={() => navigate("/auth/login")}
              >
                Book a Ride Now
              </button>
              <button className="border border-[#570033] text-[#570033] px-4 sm:px-5 py-2 rounded text-sm font-medium hover:bg-[#570033]/5">
                Earn with Pulo
              </button>
           
            </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex -space-x-2">
                <img
                  src="/icons/passport.svg"
                  alt="user"
                  className="w-8 h-8 rounded-full border border-white object-cover"
                />
               <img
                  src="/icons/passport.svg"
                  alt="user"
                  className="w-8 h-8 rounded-full border border-white object-cover"
                />
                <img
                  src="/icons/passport.svg"
                  alt="user"
                  className="w-8 h-8 rounded-full border border-white object-cover"
                />
                <img
                  src="/icons/passport.svg"
                  alt="user"
                  className="w-8 h-8 rounded-full border border-white object-cover"
                />
              </div>
              <div className="text-xs text-gray-700">
                <p className="font-semibold">10k+</p>
                <p className="font-medium">Active users</p>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full">
            <img
              src="/images/ride-hero.jpg"
              alt="Pulo ride"
              className="w-full rounded-xl  object-cover"
            />
          </div>
        </section>

        {/* Why Ride */}
        <section className="max-w-4xl mx-auto rounded-2xl sm:bg-white sm:border sm:border-gray-100 p-1 sm:p-6 md:border-none md:p-0">
          <h2 className="text-2xl font-semibold text-gray-900 text-center mb-6">
            Why Ride with Pulo?
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-12">
            {[
              {
                title: "24/7 Availability",
                description:
                  "Get a ride anytime, day or night with our round-the-clock service.",
              },
              {
                title: "Affordable Rides",
                description:
                  "Competitive pricing and transparent fares with no hidden charges.",
              },
              {
                title: "Safety First",
                description:
                  "We prioritize your safety with background checks, in-app safety features and ride tracking.",
              },
            ].map((item, index) => (
              <div
                key={item.title}
                className={`${index === 2 ? "col-span-2 sm:col-span-1" : ""}`}
              >
                <PillCard title={item.title} description={item.description} />
              </div>
            ))}
          </div>
        </section>

        {/* How it works */}
        <section className="flex flex-col lg:flex-row sm:items-center sm:gap-10 gap-5 rounded-2xl sm:bg-white sm:shadow-sm sm:border sm:border-gray-100 p-4 sm:p-6 md:shadow-none md:border-none md:p-0">
            <div className="flex-1">
              <img
                src="/images/phone1.jpg"
                alt="App preview"
                className="w-full rounded-2xl shadow-md object-cover"
              />
            </div>

            {/* right side pushed to the end */}
            <div className="flex-1 flex sm:justify-end">
              <div className="space-y-6 sm:max-w-md">
                <h3 className="text-xl sm:text-2xl font-bold text-[#570033]">
                  How it works
                </h3>
                <div className="flex flex-col">
                  {steps.map((step, index) => (
                    <Step
                      key={step.number}
                      {...step}
                      isPrimary={index === 0}
                      isLast={index === steps.length - 1}
                    />
                  ))}
                </div>
                <button
                  className="max-sm:w-full bg-[#570033] text-white px-5 py-2 rounded shadow hover:bg-[#6c0a46] text-sm font-semibold"
                  type="button"
                  onClick={() => navigate("/auth/login")}
                >
                  Book a Ride Now
                </button>
              </div>
            </div>
          </section>

        {/* Earn + Driver */}
        <section className="flex flex-col lg:flex-row items-center gap-10 sm:rounded-2xl sm:bg-white sm:shadow-sm sm:border sm:border-gray-100 p-4 sm:p-6 md:shadow-none md:border-none md:p-0">
          <div className="max-sm:order-2 flex-1 flex flex-col sm:space-y-10 space-y-3">
            <div className="space-y-4">
               <h3 className="text-2xl font-semibold text-[#570033]">Earn with Pulo</h3>
            <p className="text-sm text-gray-700 font-medium leading-relaxed">
              Our users will always request your service. With higher demand, you
              earn more.
            </p>
            </div>
            <button className="max-sm:w-full self-start border border-[#61013B] text-[#570033] px-6 py-2 rounded  sm:text-lg font-medium hover:bg-[#570033]/5">
              Earn with Pulo
            </button>           
          </div>

          <div className="max-sm:order-1 flex-1">
            <img
              src="/images/driving.jpg"
              alt="Driver"
              className="w-full rounded-2xl shadow-md object-cover"
            />
          </div>
        </section>

        {/* Final CTA/form */}
        <section className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10 sm:rounded-2xl sm:bg-white sm:shadow-sm sm:border sm:border-gray-100 p-4 sm:p-6 md:shadow-none md:border-none md:p-0">
          {/* Left image */}
          <div className="flex-1">
            <img
              src="/images/phone2.jpg"
              alt="Booking"
              className="w-full rounded-2xl shadow-md object-cover"
            />
          </div>

          {/* Right side pushed to the RIGHT */}
          <div className="flex-1 flex lg:justify-end w-full">
            {/* This is the actual form card */}
            <div className="space-y-5 max-w-sm w-full">
              <div>
                <label className="block text-sm text-gray-800 mb-1">
                  Pickup
                </label>
                <div className="flex items-center gap-2 border border-gray-300 rounded px-3 py-2">
                  <MapPin className="w-4 h-4 text-gray-500" />
                  <input
                    type="text"
                    placeholder="Enter Pickup location"
                    className="w-full outline-none text-sm text-gray-700"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm  text-gray-800 mb-1">
                  Destination
                </label>
                <div className="flex items-center gap-2 border border-gray-300 rounded px-3 py-2">
                  <MapPin className="w-4 h-4 text-gray-500" />
                  <input
                    type="text"
                    placeholder="Enter Destination"
                    className="w-full outline-none text-sm text-gray-700"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm  text-gray-800 mb-1">
                  Schedule for later
                </label>
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div className="flex flex-col">
                  <label htmlFor="">Date</label>
                  <input
                    type="date"
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-700 outline-none"
                  />
                  </div>
                  
                  <div className="flex flex-col">
                    <label htmlFor="">Time</label>
                  <input
                    type="time"
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-700 outline-none"
                  />
                  </div>
                  
                </div>
              </div>

              <button className="w-full bg-[#570033] text-white rounded px-5 py-3 text-sm font-semibold hover:bg-[#6c0a46]">
                Continue
              </button>
            </div>
          </div>
        </section>

      <Testimonials className="mt-12" />

      </main>

      <Footer />
    </div>
  );
}

export default HomeRides;
